import { render, staticRenderFns } from "./bindDeviceLogin.vue?vue&type=template&id=01fc0f0c&scoped=true"
import script from "./bindDeviceLogin.vue?vue&type=script&lang=ts"
export * from "./bindDeviceLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc0f0c",
  null
  
)

export default component.exports